/* JNT Beta: minimal progressive enhancement. Gallery thumbnails, sticky buy bar, drawer body lock, community videos,
   newsletter forms and pop-up. */
(function () {
  'use strict';

  function initGallery(root) {
    var slides = root.querySelectorAll('[data-jnt-slide]');
    var thumbs = root.querySelectorAll('[data-jnt-thumb]');
    if (!slides.length || !thumbs.length) return;
    function show(id) {
      slides.forEach(function (s) {
        var active = s.getAttribute('data-jnt-slide') === id;
        s.hidden = !active;
        var v = s.querySelector('video');
        if (v && !active) v.pause();
      });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-jnt-thumb') === id ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-jnt-thumb')); });
    });
  }

  function initSticky(root) {
    var bar = document.querySelector('[data-jnt-sticky]');
    var sentinel = root.querySelector('[data-jnt-sticky-sentinel]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  function syncStickyPrice() {
    var bar = document.querySelector('[data-jnt-sticky]');
    if (!bar) return;
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    var stickyBtn = bar.querySelector('button[type="submit"]');
    var mainBtn = form.querySelector('button[type="submit"]');
    if (stickyBtn && mainBtn) {
      var obs = new MutationObserver(function () {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.setAttribute('aria-disabled', mainBtn.disabled ? 'true' : 'false');
      });
      obs.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-jnt-drawer]');
    if (!drawer) return;
    drawer.addEventListener('toggle', function () {
      document.body.classList.toggle('jnt-drawer-open', drawer.open);
      if (drawer.open) {
        var first = drawer.querySelector('.jnt-drawer__panel a, .jnt-drawer__panel button');
        if (first) first.focus();
      }
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.open) {
        drawer.open = false;
        var s = drawer.querySelector('summary');
        if (s) s.focus();
      }
    });
    var closeBtn = drawer.querySelector('[data-jnt-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { drawer.open = false; });
  }

  function initDesktopMenus() {
    var items = document.querySelectorAll('[data-jnt-menu-item]');
    items.forEach(function (d) {
      d.addEventListener('focusout', function (e) {
        if (!d.contains(e.relatedTarget)) d.open = false;
      });
    });
    document.addEventListener('click', function (e) {
      items.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }

  /* Community videos. With autoplay on (data-jnt-ugc-autoplay) they play muted while on screen and pause, muted
     again, when scrolled away. Nothing autoplays under reduced motion or data saver. Videos marked data-sound get a
     sound button; tapping such a video also turns its sound on, and tapping it again pauses it. Only one video
     plays with sound at a time. Videos without sound just play and pause on tap. */
  var ugcObserver = null;
  function ugcButton(card) {
    var li = card.parentElement;
    return li ? li.querySelector('[data-jnt-sound]') : null;
  }
  function ugcSetSound(card, on) {
    var v = card.querySelector('video');
    if (!v) return;
    v.muted = !on;
    card.classList.toggle('has-sound', on);
    var b = ugcButton(card);
    if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function ugcPlay(card) {
    var v = card.querySelector('video');
    if (!v) return;
    var p = v.play();
    var ok = function () { card.classList.add('is-playing'); };
    if (p && p.then) {
      p.then(ok).catch(function () {
        /* The browser refused playback with sound: fall back to muted playback. */
        if (!v.muted) { ugcSetSound(card, false); var p2 = v.play(); if (p2 && p2.then) p2.then(ok).catch(function () {}); }
      });
    } else ok();
  }
  function ugcPause(card) {
    var v = card.querySelector('video');
    if (!v) return;
    v.pause();
    card.classList.remove('is-playing');
  }
  function ugcSoundOn(card) {
    document.querySelectorAll('[data-jnt-video-card].has-sound').forEach(function (c) {
      if (c !== card) ugcSetSound(c, false);
    });
    ugcSetSound(card, true);
    ugcPlay(card);
  }
  function initUgcVideos() {
    var mm = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
    var autoplayOk = !mm('(prefers-reduced-motion: reduce)') && !(navigator.connection && navigator.connection.saveData) && 'IntersectionObserver' in window;
    if (autoplayOk && !ugcObserver) {
      ugcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var card = en.target;
          if (en.isIntersecting) { if (!card.classList.contains('is-playing')) ugcPlay(card); }
          else if (card.classList.contains('is-playing') || card.classList.contains('has-sound')) { ugcPause(card); ugcSetSound(card, false); }
        });
      }, { threshold: 0.45 });
    }
    document.querySelectorAll('[data-jnt-video-card]').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v || card.hasAttribute('data-jnt-bound')) return;
      card.setAttribute('data-jnt-bound', '');
      var withSound = card.hasAttribute('data-sound');
      function tap() {
        if (withSound) {
          if (v.paused) ugcSoundOn(card);
          else if (v.muted) ugcSoundOn(card);
          else ugcPause(card);
        } else if (v.paused) ugcPlay(card);
        else ugcPause(card);
      }
      card.addEventListener('click', function (e) { e.preventDefault(); tap(); });
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tap(); } });
      v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
      var b = ugcButton(card);
      if (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (v.muted || v.paused) ugcSoundOn(card);
          else ugcSetSound(card, false);
        });
      }
      if (ugcObserver && card.closest('[data-jnt-ugc-autoplay]')) ugcObserver.observe(card);
    });
  }

  /* Small storage helpers: storage can be blocked (private mode, cookies off); the site must work without it. */
  function storeGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function storeSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  var NL_SUBSCRIBED = 'jnt-nl-subscribed';
  var NL_CLOSED = 'jnt-nl-popup-closed';

  /* "Show until" lines (e.g. the next clinic): hide them after the given date (YYYY-MM-DD, inclusive). */
  function initUntil() {
    var today = new Date();
    var ymd = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
    document.querySelectorAll('[data-until]').forEach(function (el) {
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((el.getAttribute('data-until') || '').trim());
      if (m && ymd > (+m[1]) * 10000 + (+m[2]) * 100 + (+m[3])) el.hidden = true;
    });
  }

  /* Newsletter forms: chosen interests are added to the customer tags; ?interesse=<key> ticks one in advance. */
  function initNewsletterForms() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') storeSet(NL_SUBSCRIBED, '1');
    var wanted = (params.get('interesse') || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    document.querySelectorAll('form.jnt-nl__form').forEach(function (form) {
      if (form.hasAttribute('data-jnt-bound')) return;
      form.setAttribute('data-jnt-bound', '');
      var tags = form.querySelector('[data-jnt-nl-tags]');
      var boxes = form.querySelectorAll('[data-jnt-nl-interest]');
      var notice = form.querySelector('[data-jnt-nl-notice]');
      boxes.forEach(function (box) {
        var key = (box.getAttribute('data-jnt-nl-interest') || '').toLowerCase();
        if (key && wanted.indexOf(key) !== -1) {
          box.checked = true;
          var msg = box.getAttribute('data-notice');
          if (notice && msg) { notice.querySelector('[data-jnt-nl-notice-text]').textContent = msg; notice.hidden = false; }
        }
      });
      form.addEventListener('submit', function () {
        if (tags) {
          var list = (tags.getAttribute('data-base') || '').split(',');
          boxes.forEach(function (box) { if (box.checked) list.push(box.value); });
          var seen = {};
          tags.value = list.map(function (t) { return t.trim(); }).filter(function (t) { if (!t || seen[t]) return false; seen[t] = true; return true; }).join(', ');
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { setTimeout(function () { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }, 0); }
      });
      var done = form.querySelector('[data-jnt-nl-done]');
      if (done && window.location.hash === '#' + form.id && !form.closest('dialog')) done.focus();
    });
  }

  /* Newsletter pop-up: opens once after a delay, after scrolling or when the mouse leaves the page (desktop),
     whichever comes first. Closing hides it for data-days days; signing up hides it for good. */
  function initNewsletterPopup() {
    var dlg = document.querySelector('[data-jnt-popup]');
    if (!dlg || dlg.hasAttribute('data-jnt-bound')) return;
    dlg.setAttribute('data-jnt-bound', '');
    if (typeof dlg.showModal !== 'function') return;
    var html = document.documentElement;
    var lastFocus = null;
    function open() {
      if (dlg.open) return;
      lastFocus = document.activeElement;
      dlg.showModal();
      html.classList.add('jnt-pop-lock');
      var done = dlg.querySelector('[data-jnt-nl-done]');
      if (done) done.focus();
    }
    dlg.addEventListener('close', function () {
      html.classList.remove('jnt-pop-lock');
      if (!dlg.hasAttribute('data-design-mode') && !storeGet(NL_SUBSCRIBED)) storeSet(NL_CLOSED, String(Date.now()));
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    });
    dlg.querySelectorAll('[data-jnt-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { dlg.close(); });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var form = dlg.querySelector('form');
    if (form) form.addEventListener('submit', function () { storeSet(NL_SUBSCRIBED, '1'); });

    /* Back from posting the pop-up form: show the thank-you (or the error) in the pop-up. */
    var formId = dlg.getAttribute('data-form-id');
    if (formId && window.location.hash === '#' + formId) {
      if (!dlg.querySelector('[data-jnt-nl-done]')) { try { window.localStorage.removeItem(NL_SUBSCRIBED); } catch (e) {} }
      open();
      return;
    }
    if (dlg.hasAttribute('data-design-mode')) return;
    if (storeGet(NL_SUBSCRIBED)) return;
    var closedAt = parseInt(storeGet(NL_CLOSED) || '0', 10);
    var days = parseFloat(dlg.getAttribute('data-days')) || 7;
    if (closedAt && Date.now() - closedAt < days * 864e5) return;
    /* Visitors arriving from a newsletter e-mail are already on the list. */
    if (/[?&](utm_medium=e-?mail|utm_source=shopify_email|_kx=)/i.test(window.location.search)) { storeSet(NL_CLOSED, String(Date.now())); return; }
    if (dlg.hasAttribute('data-no-mobile') && !(window.matchMedia && window.matchMedia('(min-width: 750px)').matches)) return;

    var delay = (parseFloat(dlg.getAttribute('data-delay')) || 0) * 1000;
    var scrollPct = parseFloat(dlg.getAttribute('data-scroll')) || 0;
    var MIN = 4000, start = Date.now(), fired = false, timer = null;
    function busy() { return document.body.classList.contains('jnt-drawer-open') || document.querySelector('dialog[open]:not([data-jnt-popup])') || (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)); }
    function fire() {
      if (fired) return;
      var wait = MIN - (Date.now() - start);
      if (wait > 0) { clearTimeout(timer); timer = setTimeout(fire, wait); return; }
      if (busy()) { clearTimeout(timer); timer = setTimeout(fire, 5000); return; }
      fired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
      open();
    }
    function onScroll() {
      var de = document.documentElement;
      var max = de.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) * 100 >= scrollPct) fire();
    }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) fire(); }
    if (delay > 0) timer = setTimeout(fire, delay);
    else if (!scrollPct) timer = setTimeout(fire, MIN);
    if (scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
  }
  /* Theme editor: open the pop-up while its section is selected. */
  document.addEventListener('shopify:section:select', function (e) {
    var dlg = document.querySelector('[data-jnt-popup][data-section-id="' + e.detail.sectionId + '"]');
    if (dlg && !dlg.open && dlg.showModal) dlg.showModal();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var dlg = document.querySelector('[data-jnt-popup][data-section-id="' + e.detail.sectionId + '"]');
    if (dlg && dlg.open) dlg.close();
  });

  function init() {
    initUgcVideos();
    initUntil();
    initNewsletterForms();
    initNewsletterPopup();
    document.querySelectorAll('[data-jnt-product]').forEach(function (root) {
      initGallery(root);
      initSticky(root);
    });
    syncStickyPrice();
    initDrawer();
    initDesktopMenus();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
